module.exports = __webpack_public_path__ + "img/index3.6018aa37.png";